<script setup lang="ts">
import { brand } from '../config/brand'
import { defaultLandingPage } from '../content/landingPages'

const props = defineProps<{
  withBase: (p: string) => string
  title?: string
}>()
</script>

<template>
  <header class="nav" role="banner">
    <div class="container">
      <div class="navRow">
        <a class="brand" :href="props.withBase('/ai-workbench/')" :aria-label="brand.productName">
          <img class="logoMark" :src="props.withBase(brand.logoPath)" alt="" aria-hidden="true" width="48" height="48" />
          <div class="headerTitle">
            <strong>{{ props.title || brand.productName }}</strong>
            <span>{{ brand.slogan }}</span>
          </div>
        </a>

        <nav class="navLinks" aria-label="Top Navigation">
          <a class="mutedBtn" :href="props.withBase('/ai-workbench/')">工作台</a>
          <a class="mutedBtn" :href="props.withBase(defaultLandingPage.routePath)">首页</a>
        </nav>
      </div>
    </div>
  </header>
</template>
